import styled from "@emotion/styled";

export const TruckShippingInfoContent = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: 8,
	alignItems: "flex-end",
	"> div": {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		gap: 8
	}
}));

export const TruckStopWrapper = styled.div<{ hasError?: boolean }>(({ theme, hasError }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "flex-start",
	gap: 8,
	"> span": {
		...theme.project.typography.subtitle.subtitle2,
		color: theme.project.colors.fontColors.main
	},
	"> div": {
		display: "flex",
		gap: 16,
		width: "100%",
		"> div": {
			flex: 1,
			width: "100%"
		},
		"> button": {
			color: theme.project.colors.fontColors.secondary,
			textDecoration: "underline",
			padding: 0,
			minWidth: 56,
			fontSize: "1rem",
			marginBottom: hasError ? 22 : 0
		},
		[theme.breakpoints.down("md")]: {
			flexDirection: "column",
			gap: 8,
			alignItems: "flex-start",
			"> button": {
				marginBottom: 0
			}
		}
	},
	"> button": {
		padding: 0,
		marginTop: "8px",
		textDecoration: "underline"
	}
}));

export const RequestDateWrapper = styled.div<{ isError?: boolean }>(({ theme, isError }) => ({
	width: "calc(50% - 8px)",
	[theme.breakpoints.down("md")]: {
		width: "100%"
	},
	...(isError && {
		color: theme.project.colors.semanticColors.error,
		"> div": {
			paddingBottom: "0 !important"
		},
		"& .MuiFormControl-root": {
			label: {
				color: theme.project.colors.semanticColors.error + " !important"
			},
			div: {
				color: theme.project.colors.semanticColors.error
			},
			fieldset: {
				borderColor: theme.project.colors.semanticColors.error
			}
		}
	})
}));
